export const QUERY_PARAM_OPENER = 'opener';

export const OPENER = {
  HIGHLIGHT: 'highlight',
  INCOMING_FEEDBACK_RESPONSE: 'incoming-feedback-response',
  SURVEY_RESPONSE: 'survey-response',
  FUNNELS: 'funnels',
};
